import styled from 'styled-components';
import { TableHeader } from 'ui/tableHeader';
import { CampaignsSendMessagesLogsTableColumnData } from '../../types';
import { NoCampaigns, NoResults } from './EmptyState';

const EmptyTableHeader = styled(TableHeader)`
display: flex;
justify-content:space-between;
`;

export const enum EmptyTableType {
  NoResults = 'noResults',
  NoCampaigns = 'noCampaigns',
}

interface EmptyTableContentProps {
  type: EmptyTableType;
  tableColumnsConfig: CampaignsSendMessagesLogsTableColumnData[];
}

export const EmptyTableContent = ({ type, tableColumnsConfig }: EmptyTableContentProps) => (
  <>
    <EmptyTableHeader columns={tableColumnsConfig} />
    {type === EmptyTableType.NoResults ? <NoResults /> : <NoCampaigns />}
  </>
);
